import React from "react";
import ReactDOM from "react-dom/client";
import App from "./App";

// Ensure the app is rendered inside the div with the id 'root'
const rootElement = document.getElementById("root");

if (rootElement) {
  const root = ReactDOM.createRoot(rootElement);
  root.render(
    <React.StrictMode>
      <App />
    </React.StrictMode>
  );
} else {
  console.error("Root element not found");
}


